var _g, _g2, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftGridImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 641,
    viewBox: "0 0 510 641",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 51.4297,
    y1: 10.1602,
    x2: 51.4297,
    y2: 506.805,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.0938,
    y1: 2.17306e-8,
    x2: 93.0937,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.766,
    y1: 2.17306e-8,
    x2: 134.766,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.43,
    y1: 2.17306e-8,
    x2: 176.43,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.094,
    y1: 2.17306e-8,
    x2: 218.094,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.766,
    y1: 2.17306e-8,
    x2: 259.766,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.43,
    y1: 2.17306e-8,
    x2: 301.43,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.094,
    y1: 2.17306e-8,
    x2: 343.094,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.766,
    y1: 2.17306e-8,
    x2: 384.766,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 426.43,
    y1: 2.17306e-8,
    x2: 426.43,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 468.094,
    y1: 2.17306e-8,
    x2: 468.094,
    y2: 506.806,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 509.523,
    y1: 40.2852,
    x2: 8.99634,
    y2: 40.2851,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 509.523,
    y1: 82.7188,
    x2: 8.99634,
    y2: 82.7187,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 509.523,
    y1: 125.148,
    x2: 8.99634,
    y2: 125.148,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 509.523,
    y1: 167.582,
    x2: 8.99634,
    y2: 167.582,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 509.523,
    y1: 210.012,
    x2: 8.99634,
    y2: 210.012,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 509.523,
    y1: 252.445,
    x2: 8.99634,
    y2: 252.445,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 509.523,
    y1: 294.875,
    x2: 8.99634,
    y2: 294.875,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 509.523,
    y1: 337.309,
    x2: 8.99634,
    y2: 337.309,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 509.523,
    y1: 379.742,
    x2: 8.99634,
    y2: 379.742,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 509.523,
    y1: 422.172,
    x2: 8.99634,
    y2: 422.172,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 509.523,
    y1: 464.605,
    x2: 8.99634,
    y2: 464.605,
    stroke: "#7551FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "left-grid-ellipse",
    filter: "url(#filter0_f_1355_24325)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.943,
    cy: 455.041,
    rx: 91.8916,
    ry: 194.968,
    transform: "rotate(124.141 212.943 455.041)",
    fill: "url(#paint0_linear_1355_24325)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 412.781,
    cy: 308.531,
    r: 1.78137,
    fill: "#7551FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1355_24325",
    x: 41.6874,
    y: 319.965,
    width: 342.516,
    height: 270.153,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.902389,
    result: "effect1_foregroundBlur_1355_24325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1355_24325",
    x1: 152.099,
    y1: 281.047,
    x2: 231.455,
    y2: 646.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF9FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftGridImage1);
export default __webpack_public_path__ + "static/media/LeftGridImage1.54617711a1bfcb948da66fb327d3e7e7.svg";
export { ForwardRef as ReactComponent };